<template>
  <div >
    <Header
        @onRefreshClick="onRefresh"
        :leftArrow="true"
        :leftText="''"
        @leftClick="onClickLeft"
        :rightIcons="true"
    >
    </Header>
    <div class="home watch watch_movie detail">
      <div class="movie-detail_inner">
        <div class="movie-detail_img" >
          <video ref="video" :src="videoSrc" playsinline controls style="width: 100%;"></video>
          <button class="movie-playback_btn" v-show="!isPlaying" @click="toggleVideo">
            <img src="@/assets/img/home/icon_playback.png" alt="再生">
          </button>
        </div>
        <div class="movie-detail_info" v-show="recordDetail">
          <p class="movie-detail_txt" v-show="recordDetail.compose_flg != 1 && recordDetail.compose_flg != 2">
            <span class="movie-detail_cont-name">録画状態</span>
            <button class="status_btn yellow_color" @click="startCompose">合成を開始</button>
          </p>
          <p class="movie-detail_txt"  v-show="recordDetail.compose_flg == 1">
            <span class="movie-detail_cont-name">録画状態</span>
            <button class="status_btn yellow_color">作成中</button>
          </p>
          <p class="movie-detail_txt" v-show="recordDetail.compose_flg == 2">
            <span class="movie-detail_cont-name">録画状態</span>
            <button class="status_btn green_color">再生</button>
          </p>
          <p class="movie-detail_txt">
            <span class="movie-detail_cont-name">録画開始時刻</span>
            {{recordDetail.record_start_at}}
          </p>
          <p class="movie-detail_txt">
            <span class="movie-detail_cont-name">録画終了時刻</span>
            {{recordDetail.record_end_at}}
          </p>
          <p class="movie-detail_txt">
            <span class="movie-detail_cont-name">録画者</span>
            {{ recordDetail.record_user_name }}
          </p>
          <p class="movie-detail_txt">
            <span class="movie-detail_cont-name">送信者</span>
            {{ recordDetail.call_user_name }}
          </p>
          <p class="movie-detail_txt">
            <span class="movie-detail_cont-name">受信者</span>
            {{ recordDetail.answer_user_name }}
          </p>
        </div>
      </div>
    </div>
    <div>

    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { getVideoRecordDetail ,updateRecordFlg} from "@/services/video.js";
import 'vant/es/toast/style';

export default {
  data() {
    return {
      filename:"",
      videoSrc:"",
      id:"",
      recordDetail: {
        record_start_at:"",
        record_end_at:"",
        answer_user_name:"",
        call_user_name:"",
        record_user_name:"",
      },
      isPlaying: false,
      recordDetailInterval:null,
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.id = this.$route.query.id;
    this.initRecordDetail();
    const video = this.$refs.video;
    video.addEventListener('play', this.onPlay);
    video.addEventListener('pause', this.onPause);
    this.recordDetailInterval = setInterval(() => {
      if(!this.isPlaying){
        this.initRecordDetail();
      }
    }, 10000);
  },
  created() {
  },
  beforeUnmount() {
    const video = this.$refs.video;
    video.removeEventListener('play', this.onPlay);
    video.removeEventListener('pause', this.onPause);
    if(this.recordDetailInterval){
      clearInterval(this.recordDetailInterval);
    }
  },
  methods: {
    toggleVideo() {
      const video = this.$refs.video;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
    onPlay() {
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    startCompose(){
      updateRecordFlg({id:this.recordDetail.id}).then(() => {
        this.recordDetail.compose_flg = 1;
      });
    },
    initRecordDetail(){
      getVideoRecordDetail({id:this.id}).then((res) => {
        this.recordDetail = res.data.data;
        if(this.recordDetail.compose_flg == 2){
          this.videoSrc = this.recordDetail.video_src;
        }else{
          this.videoSrc ="";
        }
      });
    },
    onClickLeft() {
      history.back();
    },
  },
  watch: {},
};
</script>

<style scoped>
   
  
   
.status_btn{

  border: 1px solid var(--van-contact-card-add-icon-color);
  border-radius: 20px;
  color: black;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
  margin: 1px;
  cursor: pointer;
}
.green_color{
  background-color: #4CAF50;
}
.yellow_color{
  background-color: yellow;
}
</style>
